import { gql } from "@apollo/client";

export const CALCULAR_SCHOFIELD = gql`
  query CalcularSchofield (
    $tallaEnMetros: Float!,
    $peso: Float!,
    $edad: Float!,
    $sexo: String!
  ) {
    calcularSchofield (
      input: {
        tallaEnMetros: $tallaEnMetros
        peso: $peso
        edad: $edad
        sexo: $sexo
      }
    )
}`;